import {app} from './main'
export function empty (validate) {

  return (
    (
      typeof validate === 'undefined' ||
      validate === null
    ) ||
    (
      typeof validate === 'string' &&
      (
        validate.trim().length === 0 //||
        //validate.trim().toString() === '0'
      )
    )
  ) ||
  false
}


export function getSignalPercent (value) {
  value = parseFloat(value)
  if (value > -90) return 100
  else if (value < -118) return 0
  else {
    return parseInt((-90 + (value * -1)) * 100 / 28)
  }
}

export function getStatusByPercent (percent) {
  const success = process.env.VUE_APP_PERCENT_SUCCESS || 49
  const warning = process.env.VUE_APP_PERCENT_WARNING || 19
  if (parseInt(percent) > parseInt(success)) return 'success'
  else if (parseInt(percent) > parseInt(warning)) return 'warning'
  else return 'danger'
}

export function formatDate (date) {
  const d = new Date(date)
  let month = `${  d.getMonth() + 1}`
  let day = `${  d.getDate()}`
  const year = d.getFullYear()

  if (month.length < 2) month = `0${  month}`
  if (day.length < 2) day = `0${  day}`

  return [year, month, day].join('-')
}

export function formatDateLanguages (val, opc = '') {
  const fecha = new Date(val)
  let options = { year: 'numeric', month: 'long', day: 'numeric' }
  if (opc === 'hour') {
    options = { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }
  } else if (opc === 'month') {
    options = { year: 'numeric', month: 'long' }
  }
  return fecha.toLocaleDateString(`${app.$i18n.locale}-${app.$i18n.locale.toUpperCase()}`, options)
}